import { createRouter, createWebHistory } from 'vue-router'
import Home from './App.vue' // 将原来的 App.vue 内容作为主页
import StarBti from './components/StarBti.vue' // 你刚才创建的测试页面

const routes = [
  { path: '/', component: Home },
  { path: '/star-bti', component: StarBti }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router